/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { RadiologyEhr } from '../../../interfaces/ehr/radiology-ehr';

@Injectable()
export class RadiologyEhrApi {
 // private readonly apiController: string = 'tenants/';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  getById(url: string): Observable<RadiologyEhr> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url, header);
  };
  get(url: string): Observable<RadiologyEhr> {
    // let header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.directGet(url, {headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  };

  add(url:string, data: any):Observable<any>{
    let header = new HttpHeaders();
    //header.append('Content-Type', 'multipart/form-data');
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    //return this.api.directPost(url, data, {headers:{'Content-Type': 'multipart/form-data'}});
    return this.api.directPost(url, data, header);
  }
  
  addWithProgress(url:string, data: any):Observable<any>{
    let header = new HttpHeaders();
    //header.append('Content-Type', 'multipart/form-data');
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    //return this.api.directPost(url, data, {headers:{'Content-Type': 'multipart/form-data'}});
    return this.api.directPost(url, data, {
      headers: header,
      reportProgress: true,
      observe: 'events',  // This will give us access to the upload events
    });
  }

  update(url:string, data: RadiologyEhr):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut(url, data, header);
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }

 




}
